import { DefaultModel } from './default-model';
import { StatisticByEarningRate } from './model-with-statistic';

export enum PublicUserRole {
  Supervisor = 'supervisor',
  Manager = 'manager',
  Moderator = 'moderator',
  Advertiser = 'advertiser',
  Analyst = 'analyst',
  DemoVisitor = 'demoVisitor',
  Publisher = 'publisher',
}

export enum UserRole {
  Admin = 'admin',
  Supervisor = 'supervisor',
  Manager = 'manager',
  Moderator = 'moderator',
  Advertiser = 'advertiser',
  Analyst = 'analyst',
  DemoVisitor = 'demoVisitor',
  Publisher = 'publisher',
}

export interface UserBaseModel {
  code: string;
  name: string;
  description: string;
  role: UserRole;
  earningRate: number;
  attachedPartners?: string[];
  attachedRtb?: string;
}

export interface UserModel extends UserBaseModel, DefaultModel {
  appSettings?: {
    earningsMultiplier: number;
  };
  hasAttachedPartners?: boolean;
  hasAttachedRtb?: boolean;
}

export interface UserStatisticEntity
  extends UserModel,
    Omit<StatisticByEarningRate, 'earningRate'> {
  group: string;
}
